// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1xMYM","calendarButtons":"ClockData_calendarButtons__1BinQ"};